class CollectionInfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.nextUrl = this.dataset.nextUrl || null;
    this.loading = false;
    this.sentinel = this.querySelector('.infinite-scroll__sentinel');
    this.spinner = this.querySelector('.infinite-scroll__spinner');
    this.grid = document.getElementById('product-grid');

    if (!this.nextUrl || !this.sentinel || !this.grid) {
      if (this.sentinel) this.sentinel.remove();
      return;
    }

    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      rootMargin: '600px 0px 600px 0px',
    });
    this.observer.observe(this.sentinel);
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !this.loading && this.nextUrl) {
        this.loadNextPage();
      }
    });
  }

  loadNextPage() {
    if (!this.nextUrl) return;
    this.loading = true;
    if (this.spinner) this.spinner.hidden = false;

    const url = new URL(this.nextUrl, window.location.origin);
    url.searchParams.set('section_id', this.sectionId);

    fetch(url.toString())
      .then((response) => response.text())
      .then((text) => {
        const parser = new DOMParser();
        const html = parser.parseFromString(text, 'text/html');
        const newGrid = html.getElementById('product-grid');
        const newScroll = html.querySelector('collection-infinite-scroll');

        if (newGrid && this.grid) {
          Array.from(newGrid.children).forEach((child) => {
            this.grid.appendChild(child);
          });
        }

        if (newScroll && newScroll.dataset.nextUrl) {
          this.nextUrl = newScroll.dataset.nextUrl;
        } else {
          this.nextUrl = null;
          if (this.observer) this.observer.disconnect();
          if (this.sentinel) this.sentinel.remove();
        }
      })
      .catch(() => {
        this.nextUrl = null;
        if (this.observer) this.observer.disconnect();
      })
      .finally(() => {
        this.loading = false;
        if (this.spinner) this.spinner.hidden = true;
      });
  }
}

customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
